// extracted by mini-css-extract-plugin
export default {"value":"Overview_value__CWJSb","title":"Overview_title__RgRX1","dot":"Overview_dot__L08Bn","tHeader":"Overview_tHeader__PJ8i5","tBody":"Overview_tBody__tlg6r"};